<div class="dashboard-wrapper">
    <div class="light-theme">
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
            <div>
                <div class="container-fluid">
                    <div class="row">
                        <div
                            class="col-12 col-lg-3 border-top border-lg-bottom d-flex flex-column justify-content-between">
                            <div class="py-4 py-lg-5">
                                <image-upload #imageUpload></image-upload>
                            </div>
                            <div class="d-none d-lg-block py-4 text-center">
                                <button [disabled]="loading" class="btn btn-primary">
                                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                    update profile
                                </button>
                                <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-9 light-theme-alt border-lg-left border-bottom">
                            <div class="row">
                                <div class="col-12 col-md-6 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">First Name</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <input type="text" formControlName="firstName"
                                                    class="form-control text-xlarge" />
                                                <ng-container *ngFor="let validation of validationMessages.firstName">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'firstName')">{{validation.message}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 border-top border-md-left">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">Last Name</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <input type="text" formControlName="lastName"
                                                    class="form-control text-xlarge" />
                                                <ng-container *ngFor="let validation of validationMessages.lastName">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'lastName')">{{validation.message}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">Email Adress</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <input type="text" formControlName="emailAddress" readonly
                                                    class="form-control text-xlarge" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">About You</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <textarea rows="8" type="text" formControlName="aboutYou"
                                                    class="form-control text-xlarge"></textarea>
                                                <ng-container *ngFor="let validation of validationMessages.aboutYou">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'aboutYou')">{{validation.message}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">Company Name</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <input type="text" formControlName="company"
                                                    class="form-control text-xlarge" />
                                                <ng-container *ngFor="let validation of validationMessages.company">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'company')">{{validation.message}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 border-top border-md-left">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">Role at Company</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <input type="text" formControlName="companyRol"
                                                    class="form-control text-xlarge" />
                                                <ng-container *ngFor="let validation of validationMessages.companyRol">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'companyRol')">
                                                        {{validation.message}}</div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 border-top">
                                    <div class="row pt-4">
                                        <div class="col-12 subtitle">Location</div>
                                    </div>
                                    <div class="py-4">
                                        <div class="p-4 border">
                                            <div class="row">
                                                <div class="col-12 subtitle">Country</div>
                                            </div>
                                            <div class="row pt-2">
                                                <div class="col-12 ">
                                                    <ng-select [items]="countries" 
                                                            bindLabel="name" 
                                                            bindValue="id"
                                                            placeholder="Select country"
                                                            [multiple]="false"
                                                            notFoundText="No countries found"
                                                            (change)="countryValueChanged($event)"
                                                            formControlName="country">
                                                    </ng-select>
                                                    <ng-container *ngFor="let validation of validationMessages.country">
                                                        <div class="error-message is-invalid text-red"
                                                            *ngIf="hasError(validation, 'country')">
                                                            {{validation.message}}</div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-4 border-left border-right" *ngIf="states.length > 0">
                                            <div class="row">
                                                <div class="col-12 subtitle">State</div>
                                            </div>
                                            <div class="row pt-2">
                                                <div class="col-12 ">
                                                    <ng-select [items]="states" 
                                                        bindLabel="name" 
                                                        bindValue="id"
                                                        placeholder="Select state"
                                                        [multiple]="false"
                                                        notFoundText="No states found"
                                                        (change)="stateValueChanged($event)"
                                                        formControlName="state">
                                                    </ng-select>
                                                    
                                                    <ng-container *ngFor="let validation of validationMessages.state">
                                                        <div class="error-message is-invalid text-red"
                                                            *ngIf="hasError(validation, 'state')">{{validation.message}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-4 border">
                                            <div class="row">
                                                <div class="col-12 subtitle">City</div>
                                            </div>
                                            <div class="row pt-2">
                                                <div class="col-12 ">
                                                    <ng-select [items]="cities" 
                                                        bindLabel="name" 
                                                        bindValue="id"
                                                        placeholder="Select city"
                                                        [multiple]="false"
                                                        notFoundText="No cities found"
                                                        formControlName="city">
                                                    </ng-select>
                                                    <ng-container *ngFor="let validation of validationMessages.city">
                                                        <div class="error-message is-invalid text-red"
                                                            *ngIf="hasError(validation, 'city')">{{validation.message}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">Sector</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <ng-select [items]="sectors" 
                                                    bindLabel="name" 
                                                    bindValue="id"
                                                    placeholder="Select sector"
                                                    [multiple]="true"
                                                    notFoundText="No sectors found"
                                                    formControlName="sectors">
                                                </ng-select>
                                                <ng-container *ngFor="let validation of validationMessages.sectors">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'sectors')">{{validation.message}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">Company Website</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <input type="text" autocapitalize="off" formControlName="companyWebsite"
                                                    class="form-control text-xlarge" />
                                                <ng-container
                                                    *ngFor="let validation of validationMessages.companyWebsite">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'companyWebsite')">
                                                        {{validation.message}}</div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle">About Your Company</div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <textarea rows="8" type="text" formControlName="aboutYourCompany"
                                                    class="form-control text-xlarge"></textarea>
                                                <ng-container
                                                    *ngFor="let validation of validationMessages.aboutYourCompany">
                                                    <div class="error-message is-invalid text-red"
                                                        *ngIf="hasError(validation, 'aboutYourCompany')">
                                                        {{validation.message}}</div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 border-top">
                                    <div class="py-4">
                                        <div class="row">
                                            <div class="col-12 subtitle"><i>CONNECT TO SLACK</i></div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                Connecting your profile to the Equity is Dynamic Slack will help other people in the community connect with you more easily.
                                            </div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col-12 ">
                                                <a role="button" [href]="equityIsDynamicUrl" (click)="onConnectToSlack()" class="btn btn-secondary">CONNECT YOUR PROFILE TO SLACK</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 border-top d-lg-none py-4 text-center">
                                    <button [disabled]="loading" class="btn btn-primary">
                                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                        update profile
                                    </button>
                                    <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>